import { DistributionState } from './types';

const initialState: DistributionState = {
  releaseRequests: {},
  releases: {},
  genres: [],
};

export default initialState;
